/**
 * Skymedic UK - Conversion Optimization Scripts
 * ==============================================
 * Handles:
 * - Sticky add-to-cart bar show/hide (IntersectionObserver)
 * - Announcement bar rotation + close + localStorage
 * - Exit intent popup trigger (desktop, once per session)
 * - Recently viewed products tracking (localStorage, max 10)
 * - Sticky add-to-cart form AJAX submission
 * - Product page trust indicators injection
 */

(function () {
  'use strict';

  /* =========================================================
   * Locale-aware string helper.
   * Reads <html lang> and returns BR/MA/EN labels.
   * ========================================================= */
  var SKYMEDIC_LOCALE = (function () {
    var lang = (document.documentElement.lang || 'en').toLowerCase();
    if (lang.indexOf('pt') === 0) return 'pt';
    if (lang.indexOf('fr') === 0) return 'fr';
    return 'en';
  })();
  function smT(strs) {
    return strs[SKYMEDIC_LOCALE] || strs.en;
  }
  // Common UI strings used across this script
  var SM_STRINGS = {
    add_to_cart: smT({ pt: 'Adicionar ao Carrinho', fr: 'Ajouter au Panier', en: 'Add to Cart' }),
    sold_out:    smT({ pt: 'Esgotado',              fr: 'Épuisé',              en: 'Sold Out' }),
    added:       smT({ pt: 'Adicionado!',           fr: 'Ajouté!',             en: 'Added!' }),
    error:       smT({ pt: 'Erro. Tente de novo.',  fr: 'Erreur. Réessayez.',  en: 'Error. Try again.' }),
    free_shipping_unlock: smT({
      pt: 'Faltam {{amount}} para FRETE GRÁTIS',
      fr: 'Plus que {{amount}} pour la LIVRAISON GRATUITE',
      en: 'Only {{amount}} away from FREE SHIPPING'
    }),
    free_shipping_unlocked: smT({
      pt: '🎉 Você ganhou FRETE GRÁTIS!',
      fr: '🎉 Vous avez la LIVRAISON GRATUITE!',
      en: '🎉 You\'ve unlocked FREE SHIPPING!'
    }),
    cart_added_toast: smT({
      pt: 'Adicionado ao carrinho',
      fr: 'Ajouté au panier',
      en: 'Added to cart'
    }),
    view_cart: smT({ pt: 'Ver carrinho', fr: 'Voir le panier', en: 'View cart' }),
    checkout_label: smT({ pt: 'Finalizar compra', fr: 'Paiement', en: 'Checkout' })
  };

  /* Locale-aware money formatting (cents -> display string). */
  function smMoney(cents) {
    var v = (cents / 100).toFixed(2);
    if (SKYMEDIC_LOCALE === 'pt') return 'R$ ' + v.replace('.', ',');
    if (SKYMEDIC_LOCALE === 'fr') return v.replace('.', ',') + ' DH';
    return '£' + v;
  }

  /* =========================================================
   * 0. PRODUCT TRUST INDICATORS (inject after buy buttons)
   * ========================================================= */

  function initProductTitleCase() {
    // Convert ALL CAPS product titles to Title Case
    var mainSection = document.querySelector('[id*="__main"]');
    if (!mainSection) return;
    var h1 = mainSection.querySelector('h1');
    if (!h1) return;
    var text = h1.textContent.trim();
    // Only transform if mostly uppercase
    if (text === text.toUpperCase() && text.length > 1) {
      h1.textContent = text.replace(/\w\S*/g, function(word) {
        // Keep short words like "II", "III", "UV", "SPF" uppercase
        if (word.length <= 3 && word === word.toUpperCase()) return word;
        return word.charAt(0).toUpperCase() + word.substr(1).toLowerCase();
      });
    }
  }

  function initPaymentIcons() {
    if (document.querySelector('.product-payment-icons')) return;
    var mainSection = document.querySelector('[id*="__main"]');
    if (!mainSection) return;
    var buyBlock = mainSection.querySelector('span.buy-buttons-block') || mainSection.querySelector('.buy-buttons-block');
    if (!buyBlock) return;

    var iconsHTML = '<div class="product-payment-icons" aria-label="Accepted payment methods">' +
      '<span class="product-payment-icons__icon" title="Visa"><svg viewBox="0 0 38 24" fill="none"><rect width="38" height="24" rx="3" fill="#fff"/><path d="M15.6 16.4l1.7-10h2.2l-1.7 10h-2.2zm8.8-10l-2.1 6.9-.9-4.6c-.1-.5-.5-.7-1-.7h-3.5l-.1.3c.8.2 1.7.5 2.2.8l1.9 7.3h2.3l3.5-10h-2.3zm5.3 10h2l-1.7-10h-1.8c-.5 0-.9.3-1 .7l-3 9.3h2.1l.4-1.2h2.6l.4 1.2zm-2.2-2.8l1.1-3 .6 3h-1.7zM13.5 6.4l-2 6.8-.2-1.2c-.4-1.3-1.6-2.8-2.9-3.5l1.8 7.5h2.2l3.3-9.6h-2.2z" fill="#1A1F71"/><path d="M9.2 6.4H5.9l-.1.3c2.6.7 4.3 2.3 5 4.2l-.7-3.7c-.1-.5-.5-.8-1-.8z" fill="#F9A533"/></svg></span>' +
      '<span class="product-payment-icons__icon" title="Mastercard"><svg viewBox="0 0 38 24" fill="none"><rect width="38" height="24" rx="3" fill="#fff"/><circle cx="15" cy="12" r="7" fill="#EB001B"/><circle cx="23" cy="12" r="7" fill="#F79E1B"/><path d="M19 7.3a7 7 0 0 1 2.6 4.7A7 7 0 0 1 19 16.7a7 7 0 0 1-2.6-4.7A7 7 0 0 1 19 7.3z" fill="#FF5F00"/></svg></span>' +
      '<span class="product-payment-icons__icon" title="American Express"><svg viewBox="0 0 38 24" fill="none"><rect width="38" height="24" rx="3" fill="#2557D6"/><text x="19" y="15" text-anchor="middle" fill="#fff" font-size="7" font-weight="700" font-family="sans-serif">AMEX</text></svg></span>' +
      '<span class="product-payment-icons__icon" title="PayPal"><svg viewBox="0 0 38 24" fill="none"><rect width="38" height="24" rx="3" fill="#fff"/><path d="M26.2 8.3c.3-1.6 0-2.7-1-3.7C24.1 3.4 22.2 3 19.8 3h-5.3c-.4 0-.8.3-.9.7l-2.2 14c-.1.3.2.6.5.6h3.9l1-6.2c.1-.4.5-.7.9-.7h1.8c3.6 0 6.4-1.5 7.2-5.7 0 0 0-.1 0-.1-.1 0 0 0 0 0 .2-1.4.2-2.3-.5-3.3z" fill="#27346A"/><path d="M26.2 8.3c-.8 4.2-3.6 5.7-7.2 5.7h-1.8c-.4 0-.8.3-.9.7l-.9 5.8c0 .3.2.5.5.5h3.2c.4 0 .7-.3.8-.6l.7-4.4c.1-.4.4-.6.8-.6h.5c3.2 0 5.7-1.3 6.4-5 .3-1.6.2-2.8-.6-3.7-.2-.2-.3-.3-.5-.4z" fill="#2790C3"/></svg></span>' +
      '<span class="product-payment-icons__icon" title="Apple Pay"><svg viewBox="0 0 38 24" fill="none"><rect width="38" height="24" rx="3" fill="#000"/><text x="19" y="15" text-anchor="middle" fill="#fff" font-size="8" font-weight="600" font-family="sans-serif">Pay</text></svg></span>' +
    '</div>';

    var wrapper = document.createElement('div');
    wrapper.innerHTML = iconsHTML;
    buyBlock.parentNode.insertBefore(wrapper.firstChild, buyBlock.nextSibling);
  }

  function titleCaseText(text) {
    return text.replace(/\w\S*/g, function(word) {
      if (word.length <= 3 && word === word.toUpperCase()) return word;
      return word.charAt(0).toUpperCase() + word.substr(1).toLowerCase();
    });
  }

  function fixAllCapsHeadings() {
    var headings = document.querySelectorAll('h1, h2, h3, h4, h5');
    headings.forEach(function(el) {
      var text = el.textContent.trim();
      if (text === text.toUpperCase() && text.length > 3 && !el.dataset.titleCased) {
        el.textContent = titleCaseText(text);
        el.dataset.titleCased = '1';
      }
    });
  }

  function initProductCardTitleCase() {
    fixAllCapsHeadings();
    // Use MutationObserver to catch async-loaded content (recommendations, recently viewed)
    if ('MutationObserver' in window) {
      var observer = new MutationObserver(function(mutations) {
        var hasNewNodes = false;
        for (var i = 0; i < mutations.length; i++) {
          if (mutations[i].addedNodes.length > 0) { hasNewNodes = true; break; }
        }
        if (hasNewNodes) fixAllCapsHeadings();
      });
      observer.observe(document.body, { childList: true, subtree: true });
    }
  }

  function initProductTrustIndicators() {
    // Don't inject twice
    if (document.querySelector('.product-trust')) return;

    // Find the main product section (not sticky ATC)
    var mainSection = document.querySelector('[id*="__main"]');
    if (!mainSection) return;

    // Find payment icons or buy block to insert after
    var paymentIcons = mainSection.querySelector('.product-payment-icons');
    var buyBlock = mainSection.querySelector('span.buy-buttons-block') ||
                   mainSection.querySelector('.buy-buttons-block') ||
                   mainSection.querySelector('product-form-component');
    if (!buyBlock && !paymentIcons) return;
    var insertAfter = paymentIcons || buyBlock;

    /* Locale-aware trust indicators */
    var langTrust = (document.documentElement.lang || 'en').toLowerCase();
    var trustLabels;
    if (langTrust.indexOf('pt') === 0) {
      trustLabels = {
        ship: 'Frete Gr\u00e1tis', shipDetail: 'Pedidos acima de R$ 500',
        secure: 'Compra Segura', secureDetail: 'Pagamento criptografado SSL',
        returns: 'Devolu\u00e7\u00e3o em 7 Dias', returnsDetail: 'Direito de arrependimento (CDC)',
        clinical: 'Clinicamente Testado', clinicalDetail: 'ISO 22716 + ISO 13485'
      };
    } else if (langTrust.indexOf('fr') === 0) {
      trustLabels = {
        ship: 'Livraison Maroc', shipDetail: '30 DH + TVA',
        secure: 'Paiement S\u00e9curis\u00e9', secureDetail: 'Cryptage SSL',
        returns: 'Retours 14 jours', returnsDetail: 'Politique sans tracas',
        clinical: 'Test\u00e9 Cliniquement', clinicalDetail: 'Certifi\u00e9 ISO 22716'
      };
    } else {
      trustLabels = {
        ship: 'Free UK Delivery', shipDetail: 'On orders over \u00a3100',
        secure: 'Secure Checkout', secureDetail: 'SSL encrypted payment',
        returns: '14-Day Returns', returnsDetail: 'Hassle-free policy',
        clinical: 'Clinically Tested', clinicalDetail: 'ISO 22716 certified'
      };
    }

    var trustHTML = '<div class="product-trust" aria-label="Purchase guarantees">' +
      '<div class="product-trust__item">' +
        '<svg class="product-trust__icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">' +
          '<rect x="1" y="3" width="15" height="13" rx="1"/><path d="M16 8h4l3 3v5h-7V8z"/><circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/>' +
        '</svg>' +
        '<div class="product-trust__text"><span class="product-trust__label">' + trustLabels.ship + '</span><span class="product-trust__detail">' + trustLabels.shipDetail + '</span></div>' +
      '</div>' +
      '<div class="product-trust__item">' +
        '<svg class="product-trust__icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">' +
          '<path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/><path d="M9 12l2 2 4-4"/>' +
        '</svg>' +
        '<div class="product-trust__text"><span class="product-trust__label">' + trustLabels.secure + '</span><span class="product-trust__detail">' + trustLabels.secureDetail + '</span></div>' +
      '</div>' +
      '<div class="product-trust__item">' +
        '<svg class="product-trust__icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">' +
          '<polyline points="1 4 1 10 7 10"/><path d="M3.51 15a9 9 0 1 0 2.13-9.36L1 10"/>' +
        '</svg>' +
        '<div class="product-trust__text"><span class="product-trust__label">' + trustLabels.returns + '</span><span class="product-trust__detail">' + trustLabels.returnsDetail + '</span></div>' +
      '</div>' +
      '<div class="product-trust__item">' +
        '<svg class="product-trust__icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">' +
          '<path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/>' +
        '</svg>' +
        '<div class="product-trust__text"><span class="product-trust__label">' + trustLabels.clinical + '</span><span class="product-trust__detail">' + trustLabels.clinicalDetail + '</span></div>' +
      '</div>' +
    '</div>';

    var wrapper = document.createElement('div');
    wrapper.innerHTML = trustHTML;
    insertAfter.parentNode.insertBefore(wrapper.firstChild, insertAfter.nextSibling);
  }

  /* =========================================================
   * 1. STICKY ADD-TO-CART
   * ========================================================= */

  function initStickyAddToCart() {
    var stickyBar = document.querySelector('[data-sticky-atc]');
    if (!stickyBar) return;

    // Find the main product form's add-to-cart button on the page
    var mainAddToCartBtn =
      document.querySelector('product-information add-to-cart-component [ref="addToCartButton"]') ||
      document.querySelector('.product-form [type="submit"][name="add"]') ||
      document.querySelector('add-to-cart-component button[ref="addToCartButton"]');

    if (!mainAddToCartBtn) return;

    // IntersectionObserver: show sticky bar when main button scrolls out of view
    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              stickyBar.setAttribute('aria-hidden', 'true');
            } else {
              // Only show when scrolled past (below the button)
              if (entry.boundingClientRect.top < 0) {
                stickyBar.setAttribute('aria-hidden', 'false');
              } else {
                stickyBar.setAttribute('aria-hidden', 'true');
              }
            }
          });
        },
        { threshold: 0, rootMargin: '0px 0px 0px 0px' }
      );
      observer.observe(mainAddToCartBtn);
    } else {
      // Fallback for older browsers
      var lastKnownScroll = 0;
      var ticking = false;
      var btnOffset = mainAddToCartBtn.getBoundingClientRect().top + window.pageYOffset;

      function recalcOffset() {
        btnOffset = mainAddToCartBtn.getBoundingClientRect().top + window.pageYOffset;
      }

      window.addEventListener('resize', recalcOffset);
      window.addEventListener('orientationchange', function () {
        setTimeout(recalcOffset, 200);
      });

      window.addEventListener('scroll', function () {
        lastKnownScroll = window.pageYOffset;
        if (!ticking) {
          window.requestAnimationFrame(function () {
            if (lastKnownScroll > btnOffset + 100) {
              stickyBar.setAttribute('aria-hidden', 'false');
            } else {
              stickyBar.setAttribute('aria-hidden', 'true');
            }
            ticking = false;
          });
          ticking = true;
        }
      });
    }

    // Quantity controls
    var qtyInput = stickyBar.querySelector('[data-sticky-atc-qty-input]');
    var minusBtn = stickyBar.querySelector('[data-sticky-atc-qty-minus]');
    var plusBtn = stickyBar.querySelector('[data-sticky-atc-qty-plus]');

    if (minusBtn && qtyInput) {
      minusBtn.addEventListener('click', function () {
        var val = parseInt(qtyInput.value, 10) || 1;
        var min = parseInt(qtyInput.min, 10) || 1;
        if (val > min) qtyInput.value = val - 1;
      });
    }

    if (plusBtn && qtyInput) {
      plusBtn.addEventListener('click', function () {
        var val = parseInt(qtyInput.value, 10) || 1;
        var max = parseInt(qtyInput.max, 10) || 99;
        if (val < max) qtyInput.value = val + 1;
      });
    }

    // Variant selector syncing
    var variantSelect = stickyBar.querySelector('[data-sticky-atc-variant-select]');
    if (variantSelect) {
      variantSelect.addEventListener('change', function () {
        var selected = variantSelect.options[variantSelect.selectedIndex];
        var priceEl = stickyBar.querySelector('[data-sticky-atc-price]');
        var submitBtn = stickyBar.querySelector('[data-sticky-atc-submit]');
        var btnText = stickyBar.querySelector('[data-sticky-atc-button-text]');
        var isAvailable = selected.getAttribute('data-available') === 'true';

        // Update price display
        if (priceEl) {
          var price = selected.getAttribute('data-price');
          var comparePrice = selected.getAttribute('data-compare-price');
          var compareAt = selected.getAttribute('data-compare-at');
          var html = '';
          if (compareAt && parseFloat(compareAt) > 0) {
            html += '<s class="sticky-atc__compare-price">' + comparePrice + '</s>';
            html += '<span class="sticky-atc__current-price sticky-atc__current-price--sale">' + price + '</span>';
          } else {
            html += '<span class="sticky-atc__current-price">' + price + '</span>';
          }
          priceEl.innerHTML = html;
        }

        // Update button state
        if (submitBtn && btnText) {
          submitBtn.disabled = !isAvailable;
          btnText.textContent = isAvailable ? SM_STRINGS.add_to_cart : SM_STRINGS.sold_out;
        }

        // Update image if variant has one
        var variantImage = selected.getAttribute('data-image');
        if (variantImage) {
          var imgEl = stickyBar.querySelector('.sticky-atc__media img');
          if (imgEl) imgEl.src = variantImage;
        }
      });
    }

    // Listen for variant changes from the main product form (Atelier dispatches custom events)
    document.addEventListener('variant:changed', function (e) {
      if (!e.detail || !e.detail.variant) return;
      var variant = e.detail.variant;
      if (variantSelect) {
        variantSelect.value = variant.id;
        variantSelect.dispatchEvent(new Event('change'));
      }
    });

    // AJAX form submission
    var stickyForm = stickyBar.querySelector('[data-sticky-atc-form]');
    if (stickyForm) {
      stickyForm.addEventListener('submit', function (e) {
        e.preventDefault();
        var submitBtn = stickyBar.querySelector('[data-sticky-atc-submit]');
        var btnText = stickyBar.querySelector('[data-sticky-atc-button-text]');
        var loader = stickyBar.querySelector('[data-sticky-atc-loader]');

        if (submitBtn.disabled) return;
        submitBtn.disabled = true;
        if (btnText) btnText.style.display = 'none';
        if (loader) loader.style.display = 'inline-flex';

        var formData = new FormData(stickyForm);
        var id = formData.get('id');
        var quantity = formData.get('quantity') || 1;

        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
          },
          body: JSON.stringify({ id: parseInt(id, 10), quantity: parseInt(quantity, 10) }),
        })
          .then(function (res) {
            if (!res.ok) throw new Error('Failed');
            return res.json();
          })
          .then(function () {
            if (btnText) {
              btnText.textContent = SM_STRINGS.added;
              btnText.style.display = '';
            }
            if (loader) loader.style.display = 'none';

            // Notify theme of cart update
            document.dispatchEvent(new CustomEvent('cart:updated'));
            fetch('/cart.js', { headers: { Accept: 'application/json' } })
              .then(function (r) { return r.json(); })
              .then(function (cart) {
                document.querySelectorAll('[data-cart-count], .cart-count').forEach(function (el) {
                  el.textContent = cart.item_count;
                });
              });

            setTimeout(function () {
              if (btnText) btnText.textContent = SM_STRINGS.add_to_cart;
              submitBtn.disabled = false;
            }, 2000);
          })
          .catch(function () {
            if (btnText) {
              btnText.textContent = 'Error - Try Again';
              btnText.style.display = '';
            }
            if (loader) loader.style.display = 'none';
            setTimeout(function () {
              if (btnText) btnText.textContent = SM_STRINGS.add_to_cart;
              submitBtn.disabled = false;
            }, 2500);
          });
      });
    }
  }

  /* =========================================================
   * 2. ANNOUNCEMENT BAR ROTATION + CLOSE
   * ========================================================= */

  function initAnnouncementBar() {
    var bar = document.querySelector('[data-announcement-bar]');
    if (!bar) return;

    var sectionId = bar.getAttribute('data-section-id');
    var storageKey = 'skymedic_announcement_closed_' + sectionId;

    // Check if user closed it within the last 24 hours
    var closedData = localStorage.getItem(storageKey);
    if (closedData) {
      try {
        var closedTime = parseInt(closedData, 10);
        var twentyFourHours = 24 * 60 * 60 * 1000;
        if (Date.now() - closedTime < twentyFourHours) {
          bar.hidden = true;
          return;
        } else {
          localStorage.removeItem(storageKey);
        }
      } catch (e) {
        localStorage.removeItem(storageKey);
      }
    }

    var messages = bar.querySelectorAll('[data-announcement-message]');
    var closeBtn = bar.querySelector('[data-announcement-close]');
    var messageCount = messages.length;
    var currentIndex = 0;
    var rotationInterval = null;

    // Read rotation speed from schema setting via data attribute or default to 4s
    var speedSetting = bar.closest('[data-section-id]');
    var speed = 4000;
    // Try to read from section settings embedded in a script tag
    var sectionEl = document.getElementById('shopify-section-' + sectionId);
    if (sectionEl) {
      var speedAttr = sectionEl.querySelector('[data-rotation-speed]');
      if (speedAttr) speed = parseInt(speedAttr.getAttribute('data-rotation-speed'), 10) * 1000;
    }

    function showMessage(index) {
      messages.forEach(function (msg, i) {
        if (i === index) {
          msg.classList.add('announcement-custom__message--active');
          msg.removeAttribute('aria-hidden');
        } else {
          msg.classList.remove('announcement-custom__message--active');
          msg.setAttribute('aria-hidden', 'true');
        }
      });
    }

    function nextMessage() {
      currentIndex = (currentIndex + 1) % messageCount;
      showMessage(currentIndex);
    }

    // Start rotation if more than 1 message
    if (messageCount > 1) {
      rotationInterval = setInterval(nextMessage, speed);

      // Pause on hover
      bar.addEventListener('mouseenter', function () {
        clearInterval(rotationInterval);
      });

      bar.addEventListener('mouseleave', function () {
        rotationInterval = setInterval(nextMessage, speed);
      });
    }

    // Close button
    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        bar.hidden = true;
        localStorage.setItem(storageKey, Date.now().toString());
        if (rotationInterval) clearInterval(rotationInterval);
        // Dispatch event in case layout needs to adjust
        document.dispatchEvent(new CustomEvent('announcement:closed'));
      });
    }
  }

  /* =========================================================
   * 3. EXIT INTENT POPUP TRIGGER
   * ========================================================= */

  function initExitIntent() {
    // Only on desktop
    if (window.innerWidth < 1024) return;

    // Don't interrupt B2B, account, cart or checkout flows with a consumer discount popup
    var eiPath = window.location.pathname.toLowerCase();
    if (/(\/cart|\/checkout|\/account)/.test(eiPath) ||
        /professional-registration|wholesale|bulk-order|pro-dashboard|affiliate/.test(eiPath)) return;

    // Only once per session
    if (sessionStorage.getItem('skymedic_exit_shown')) return;

    var popup = document.getElementById('ExitIntentPopup');
    if (!popup) return;

    var triggered = false;

    function showPopup() {
      if (triggered) return;
      triggered = true;
      sessionStorage.setItem('skymedic_exit_shown', '1');
      popup.classList.add('exit-popup--visible');
      popup.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }

    function closePopup() {
      popup.classList.remove('exit-popup--visible');
      popup.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    // Mouseleave on document (exit intent)
    document.documentElement.addEventListener('mouseleave', function (e) {
      if (e.clientY <= 0) {
        showPopup();
      }
    });

    // Close button
    var closeBtn = popup.querySelector('[data-exit-close]');
    if (closeBtn) {
      closeBtn.addEventListener('click', closePopup);
    }

    // "No thanks" link
    var noThanks = popup.querySelector('[data-exit-dismiss]');
    if (noThanks) {
      noThanks.addEventListener('click', function (e) {
        e.preventDefault();
        closePopup();
      });
    }

    // Click overlay to close
    popup.addEventListener('click', function (e) {
      if (e.target === popup) {
        closePopup();
      }
    });

    // Escape key
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && popup.classList.contains('exit-popup--visible')) {
        closePopup();
      }
    });
  }

  /* =========================================================
   * 4. RECENTLY VIEWED PRODUCTS TRACKING
   * ========================================================= */

  function initRecentlyViewed() {
    var STORAGE_KEY = 'skymedic_recently_viewed';
    var MAX_ITEMS = 12;

    // Only track on product pages
    var pathMatch = window.location.pathname.match(/\/products\/([^?#/]+)/);
    if (!pathMatch) return;

    var handle = decodeURIComponent(pathMatch[1]);
    if (!handle) return;

    var viewed = [];
    try {
      var stored = localStorage.getItem(STORAGE_KEY);
      if (stored) viewed = JSON.parse(stored);
      if (!Array.isArray(viewed)) viewed = [];
    } catch (e) {
      viewed = [];
    }

    // Remove if already exists (move to front)
    viewed = viewed.filter(function (h) { return h !== handle; });
    // Add to beginning
    viewed.unshift(handle);
    // Limit
    if (viewed.length > MAX_ITEMS) viewed = viewed.slice(0, MAX_ITEMS);

    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(viewed));
    } catch (e) {
      // Storage full, silently fail
    }
  }

  /* =========================================================
   * 5. FREE SHIPPING PROGRESS BAR
   * ========================================================= */

  function initFreeShippingBar() {
    var THRESHOLD = 10000; /* £100 in pence */
    var bar = null;

    function createBar() {
      if (document.getElementById('FreeShippingBar')) return;
      var el = document.createElement('div');
      el.id = 'FreeShippingBar';
      el.className = 'fs-bar';
      el.innerHTML =
        '<div class="fs-bar__inner">' +
          '<div class="fs-bar__content">' +
            '<svg class="fs-bar__icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><rect x="1" y="3" width="15" height="13" rx="1"/><path d="M16 8h4l3 3v5h-7V8z"/><circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/></svg>' +
            '<span class="fs-bar__text" data-fs-text></span>' +
          '</div>' +
          '<div class="fs-bar__track"><div class="fs-bar__fill" data-fs-fill></div></div>' +
        '</div>';
      document.body.appendChild(el);
      bar = el;
      injectStyles();
    }

    function injectStyles() {
      if (document.getElementById('fs-bar-styles')) return;
      var s = document.createElement('style');
      s.id = 'fs-bar-styles';
      s.textContent =
        '.fs-bar{position:fixed;bottom:0;left:0;right:0;z-index:49;transform:translateY(100%);transition:transform .4s cubic-bezier(.4,0,.2,1);pointer-events:none}' +
        '.fs-bar--visible{transform:translateY(0);pointer-events:auto}' +
        '.fs-bar__inner{max-width:480px;margin:0 auto 16px;background:#fff;border-radius:12px;box-shadow:0 4px 24px rgba(0,0,0,.1);padding:14px 20px;border:1px solid #E5E2DD}' +
        '.fs-bar__content{display:flex;align-items:center;gap:10px;margin-bottom:8px}' +
        '.fs-bar__icon{color:#1B4D6E;flex-shrink:0}' +
        '.fs-bar__text{font-family:"DM Sans",sans-serif;font-size:13px;color:#1A1A1A;line-height:1.4}' +
        '.fs-bar__text strong{font-weight:600;color:#1B4D6E}' +
        '.fs-bar__text .fs-bar__success{color:#2E7D4F;font-weight:600}' +
        '.fs-bar__track{height:4px;background:#F0EDE8;border-radius:2px;overflow:hidden}' +
        '.fs-bar__fill{height:100%;background:linear-gradient(90deg,#1B4D6E,#C9A96E);border-radius:2px;transition:width .6s ease;width:0}' +
        '.fs-bar--complete .fs-bar__fill{background:#2E7D4F}' +
        '@media(max-width:520px){.fs-bar__inner{margin:12px;border-radius:10px;padding:12px 16px}.fs-bar__text{font-size:12px}}' +
        /* Offset sticky ATC if present */
        '.sticky-atc[aria-hidden="false"]~#FreeShippingBar.fs-bar--visible,.fs-bar--visible+.sticky-atc[aria-hidden="false"]{bottom:0}';
      document.head.appendChild(s);
    }

    function update() {
      /* On pages with the inline PDP meter (product pages) the floating bar
         would be a duplicate message — let the inline meter own it there. */
      if (document.querySelector('[data-sm-fsm]')) {
        if (bar) bar.classList.remove('fs-bar--visible');
        return;
      }
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          if (!cart || cart.item_count === 0) {
            if (bar) bar.classList.remove('fs-bar--visible');
            return;
          }
          createBar();
          var total = cart.total_price; /* in pence */
          var remaining = THRESHOLD - total;
          var pct = Math.min(100, (total / THRESHOLD) * 100);
          var textEl = bar.querySelector('[data-fs-text]');
          var fillEl = bar.querySelector('[data-fs-fill]');

          if (SKYMEDIC_LOCALE === 'pt') {
            /* BR — dynamic progress toward R$ 500 free shipping (centavos). */
            var thrBR = 50000;
            var remBR = thrBR - total;
            var pctBR = Math.min(100, (total / thrBR) * 100);
            if (total >= thrBR) {
              textEl.innerHTML = '<span class="fs-bar__success">🎉 Você ganhou FRETE GRÁTIS!</span>';
              bar.classList.add('fs-bar--complete');
              fillEl.style.width = '100%';
            } else {
              textEl.innerHTML = 'Faltam <strong>R$ ' + (remBR / 100).toFixed(2).replace('.', ',') + '</strong> para FRETE GRÁTIS';
              bar.classList.remove('fs-bar--complete');
              fillEl.style.width = pctBR + '%';
            }
          } else if (SKYMEDIC_LOCALE === 'fr') {
            textEl.innerHTML = 'Livraison Maroc: <strong>30 DH + TVA</strong> sur toutes les commandes';
            bar.classList.add('fs-bar--complete');
            fillEl.style.width = '100%';
          } else if (total >= THRESHOLD) {
            /* UK cart at/over \u00a3100 \u2014 free delivery unlocked */
            textEl.innerHTML = '<span class="fs-bar__success">\ud83c\udf89 You\u2019ve unlocked FREE UK delivery!</span>';
            bar.classList.add('fs-bar--complete');
            fillEl.style.width = '100%';
          } else {
            /* UK cart below \u00a3100 \u2014 nudge toward free delivery (AOV) */
            textEl.innerHTML = 'Add <strong>\u00a3' + (remaining / 100).toFixed(2) + '</strong> for FREE UK delivery';
            bar.classList.remove('fs-bar--complete');
            fillEl.style.width = pct + '%';
          }
          bar.classList.add('fs-bar--visible');

          /* Hide if cart drawer is open (has its own shipping bar) */
          if (document.querySelector('.cart-drawer__dialog[open]')) {
            bar.classList.remove('fs-bar--visible');
            return;
          }

          /* Auto-hide after 6s if on non-cart page */
          if (window.location.pathname.indexOf('/cart') === -1) {
            setTimeout(function () {
              if (bar) bar.classList.remove('fs-bar--visible');
            }, 6000);
          }
        })
        .catch(function () {});
    }

    /* Update on cart change events */
    document.addEventListener('cart:updated', function () {
      setTimeout(update, 300);
    });

    /* Listen for fetch-based cart changes via global event */
    document.addEventListener('skymedic:cart:fetch', function () {
      setTimeout(update, 200);
    });

    /* Initial check on page load */
    update();
  }

  /* =========================================================
   * 5b. INLINE FREE SHIPPING METER (product page, under buy button)
   * ========================================================= */

  function initInlineFreeShippingMeter() {
    var meters = document.querySelectorAll('[data-sm-fsm]');
    if (!meters.length) return;

    function fmtGBP(pence) {
      return '£' + (pence / 100).toFixed(2);
    }

    function fmtMeterMoney(cents) {
      if (SKYMEDIC_LOCALE === 'pt') return 'R$ ' + (cents / 100).toFixed(2).replace('.', ',');
      return fmtGBP(cents);
    }

    function apply(meter, cart) {
      var threshold = parseInt(meter.getAttribute('data-fsm-threshold'), 10) || 10000;
      var total = (cart && typeof cart.total_price === 'number') ? cart.total_price : 0;
      var textEl = meter.querySelector('[data-fsm-text]');
      var fillEl = meter.querySelector('[data-fsm-fill]');
      var pct = Math.min(100, Math.round((total / threshold) * 100));

      if (total >= threshold) {
        if (textEl) textEl.innerHTML = (SKYMEDIC_LOCALE === 'en')
          ? '🎉 Your order qualifies for <strong>FREE UK delivery</strong>'
          : SM_STRINGS.free_shipping_unlocked;
        if (fillEl) fillEl.style.width = '100%';
        meter.classList.add('sm-fsm--complete');
      } else {
        var remaining = threshold - total;
        if (textEl) textEl.innerHTML = (SKYMEDIC_LOCALE === 'en')
          ? 'Add <strong>' + fmtGBP(remaining) + '</strong> for FREE UK delivery'
          : SM_STRINGS.free_shipping_unlock.replace('{{amount}}', '<strong>' + fmtMeterMoney(remaining) + '</strong>');
        if (fillEl) fillEl.style.width = pct + '%';
        meter.classList.remove('sm-fsm--complete');
      }
    }

    function update() {
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          meters.forEach(function (m) { apply(m, cart); });
        })
        .catch(function () {});
    }

    document.addEventListener('cart:updated', function () { setTimeout(update, 300); });
    document.addEventListener('skymedic:cart:fetch', function () { setTimeout(update, 200); });
    update();
  }

  /* =========================================================
   * 6. ADD-TO-CART SUCCESS TOAST
   * ========================================================= */

  function initCartToast() {
    var toast = null;
    var hideTimeout = null;

    function createToast() {
      if (document.getElementById('CartToast')) return;
      var el = document.createElement('div');
      el.id = 'CartToast';
      el.className = 'ct-toast';
      el.innerHTML =
        '<div class="ct-toast__inner">' +
          '<div class="ct-toast__header">' +
            '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#2E7D4F" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/></svg>' +
            '<span class="ct-toast__title">' + SM_STRINGS.cart_added_toast + '</span>' +
            '<button class="ct-toast__close" data-ct-close aria-label="Close">' +
              '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"><path d="M4 4l8 8M12 4l-8 8"/></svg>' +
            '</button>' +
          '</div>' +
          '<div class="ct-toast__product" data-ct-product></div>' +
          '<div class="ct-toast__footer">' +
            '<a href="/cart" class="ct-toast__view-cart">' + SM_STRINGS.view_cart + ' (<span data-ct-count>0</span>)</a>' +
            '<a href="/checkout" class="ct-toast__checkout">' + SM_STRINGS.checkout_label + '</a>' +
          '</div>' +
        '</div>';
      document.body.appendChild(el);
      toast = el;

      toast.querySelector('[data-ct-close]').addEventListener('click', function () {
        hideToast();
      });

      injectToastStyles();
    }

    function injectToastStyles() {
      if (document.getElementById('ct-toast-styles')) return;
      var s = document.createElement('style');
      s.id = 'ct-toast-styles';
      s.textContent =
        '.ct-toast{position:fixed;top:16px;right:16px;z-index:999;transform:translateX(calc(100% + 20px));transition:transform .35s cubic-bezier(.4,0,.2,1);pointer-events:none;width:340px;max-width:calc(100vw - 32px)}' +
        '.ct-toast--visible{transform:translateX(0);pointer-events:auto}' +
        '.ct-toast__inner{background:#fff;border-radius:10px;box-shadow:0 8px 32px rgba(0,0,0,.12);border:1px solid #E5E2DD;overflow:hidden}' +
        '.ct-toast__header{display:flex;align-items:center;gap:8px;padding:14px 16px 10px;border-bottom:1px solid #F0EDE8}' +
        '.ct-toast__title{font-family:"DM Sans",sans-serif;font-size:14px;font-weight:600;color:#2E7D4F;flex:1}' +
        '.ct-toast__close{background:none;border:none;cursor:pointer;color:#6B6B6B;padding:2px;display:flex;align-items:center;transition:color .2s}' +
        '.ct-toast__close:hover{color:#1A1A1A}' +
        '.ct-toast__product{display:flex;align-items:center;gap:12px;padding:12px 16px}' +
        '.ct-toast__product-img{width:56px;height:56px;border-radius:6px;object-fit:cover;background:#FAF8F5;border:1px solid #F0EDE8;flex-shrink:0}' +
        '.ct-toast__product-info{flex:1;min-width:0}' +
        '.ct-toast__product-name{font-family:"DM Sans",sans-serif;font-size:13px;font-weight:500;color:#1A1A1A;line-height:1.35;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden;margin:0}' +
        '.ct-toast__product-price{font-family:"DM Sans",sans-serif;font-size:13px;font-weight:600;color:#1B4D6E;margin-top:2px}' +
        '.ct-toast__footer{display:flex;gap:8px;padding:12px 16px;background:#FAFAF8;border-top:1px solid #F0EDE8}' +
        '.ct-toast__view-cart{flex:1;text-align:center;padding:10px 12px;font-family:"DM Sans",sans-serif;font-size:12px;font-weight:600;text-transform:uppercase;letter-spacing:.8px;border:1px solid #1B4D6E;color:#1B4D6E;border-radius:4px;text-decoration:none;transition:all .2s}' +
        '.ct-toast__view-cart:hover{background:#1B4D6E;color:#fff}' +
        '.ct-toast__checkout{flex:1;text-align:center;padding:10px 12px;font-family:"DM Sans",sans-serif;font-size:12px;font-weight:600;text-transform:uppercase;letter-spacing:.8px;background:#1B4D6E;color:#fff;border:1px solid #1B4D6E;border-radius:4px;text-decoration:none;transition:all .2s}' +
        '.ct-toast__checkout:hover{background:#153F5A;border-color:#153F5A}' +
        '@media(max-width:420px){.ct-toast{right:8px;top:8px;width:calc(100vw - 16px)}}';
      document.head.appendChild(s);
    }

    function showToast(item) {
      createToast();
      var productArea = toast.querySelector('[data-ct-product]');
      var imgSrc = item.image ? item.image.replace(/(\.\w+)(\?|$)/, '_120x$1$2') : '';
      productArea.innerHTML =
        (imgSrc ? '<img class="ct-toast__product-img" src="' + imgSrc + '" alt="" width="56" height="56" loading="eager">' : '') +
        '<div class="ct-toast__product-info">' +
          '<p class="ct-toast__product-name">' + escapeHTML(item.product_title || item.title || '') + '</p>' +
          '<div class="ct-toast__product-price">' + smMoney(item.final_line_price) + '</div>' +
        '</div>';

      /* Update cart count */
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          toast.querySelectorAll('[data-ct-count]').forEach(function (el) {
            el.textContent = cart.item_count;
          });
        });

      toast.classList.add('ct-toast--visible');

      if (hideTimeout) clearTimeout(hideTimeout);
      hideTimeout = setTimeout(hideToast, 5000);
    }

    function hideToast() {
      if (toast) toast.classList.remove('ct-toast--visible');
      if (hideTimeout) { clearTimeout(hideTimeout); hideTimeout = null; }
    }

    function escapeHTML(str) {
      var d = document.createElement('div');
      d.textContent = str || '';
      return d.innerHTML;
    }

    /* Listen for add-to-cart data via global event */
    document.addEventListener('skymedic:cart:item-added', function (e) {
      /* Don't show toast if cart drawer is open (it already shows the item) */
      if (document.querySelector('.cart-drawer__dialog[open]')) return;
      if (e.detail) showToast(e.detail);
    });
  }

  /* =========================================================
   * 7. NEXT-DAY DELIVERY COUNTDOWN (product pages)
   * ========================================================= */

  function initDeliveryCountdown() {
    if (!window.location.pathname.match(/\/products\//)) return;
    if (document.querySelector('.delivery-countdown')) return;

    var trustBlock = document.querySelector('.product-trust');
    var mainSection = document.querySelector('[id*="__main"]');
    if (!mainSection) return;
    var insertTarget = trustBlock || mainSection.querySelector('.product-payment-icons') || mainSection.querySelector('span.buy-buttons-block') || mainSection.querySelector('.buy-buttons-block');
    if (!insertTarget) return;

    var now = new Date();
    var day = now.getDay(); /* 0=Sun, 6=Sat */
    var hours = now.getHours();
    var minutes = now.getMinutes();

    /* Cutoff: Mon-Fri before 14:00 */
    var isWeekday = day >= 1 && day <= 5;
    var beforeCutoff = hours < 14;

    if (!isWeekday || !beforeCutoff) return; /* Only show when relevant */

    var cutoff = new Date(now);
    cutoff.setHours(14, 0, 0, 0);
    var diffMs = cutoff - now;
    var diffH = Math.floor(diffMs / 3600000);
    var diffM = Math.floor((diffMs % 3600000) / 60000);

    var el = document.createElement('div');
    el.className = 'delivery-countdown';
    el.innerHTML =
      '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#1B4D6E" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>' +
      '<span>Order within <strong>' + diffH + 'h ' + diffM + 'm</strong> for next-day delivery</span>';

    insertTarget.parentNode.insertBefore(el, insertTarget.nextSibling);

    /* Inject styles */
    if (!document.getElementById('dc-styles')) {
      var s = document.createElement('style');
      s.id = 'dc-styles';
      s.textContent =
        '.delivery-countdown{display:flex;align-items:center;gap:8px;padding:10px 14px;margin-top:12px;background:#F0F9F4;border:1px solid #C8E6D4;border-radius:6px;font-family:"DM Sans",sans-serif;font-size:13px;color:#1A1A1A;line-height:1.4}' +
        '.delivery-countdown strong{color:#1B4D6E;font-weight:600}' +
        '.delivery-countdown svg{flex-shrink:0}';
      document.head.appendChild(s);
    }

    /* Live countdown update every minute */
    setInterval(function () {
      var n = new Date();
      var c = new Date(n);
      c.setHours(14, 0, 0, 0);
      var d = c - n;
      if (d <= 0) {
        el.style.display = 'none';
        return;
      }
      var h = Math.floor(d / 3600000);
      var m = Math.floor((d % 3600000) / 60000);
      el.querySelector('strong').textContent = h + 'h ' + m + 'm';
    }, 60000);
  }

  /* =========================================================
   * 8. BACK TO TOP BUTTON
   * ========================================================= */

  function initBackToTop() {
    var btn = document.createElement('button');
    btn.id = 'BackToTop';
    btn.className = 'btt-btn';
    btn.setAttribute('aria-label', 'Back to top');
    btn.innerHTML = '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M10 16V4M4 10l6-6 6 6"/></svg>';
    document.body.appendChild(btn);

    if (!document.getElementById('btt-styles')) {
      var s = document.createElement('style');
      s.id = 'btt-styles';
      s.textContent =
        '.btt-btn{position:fixed;bottom:24px;left:24px;z-index:48;width:40px;height:40px;border-radius:50%;background:#fff;border:1px solid #E5E2DD;color:#1A1A1A;cursor:pointer;display:flex;align-items:center;justify-content:center;opacity:0;transform:translateY(12px);transition:opacity .3s ease,transform .3s ease,box-shadow .2s ease,border-color .2s ease;pointer-events:none;box-shadow:0 2px 8px rgba(0,0,0,.06);padding:0}' +
        '.btt-btn--visible{opacity:1;transform:translateY(0);pointer-events:auto}' +
        '.btt-btn:hover{border-color:#1B4D6E;color:#1B4D6E;box-shadow:0 4px 12px rgba(0,0,0,.1)}' +
        '@media(max-width:749px){.btt-btn{bottom:16px;left:16px;width:36px;height:36px}}';
      document.head.appendChild(s);
    }

    var visible = false;
    window.addEventListener('scroll', function () {
      var shouldShow = window.pageYOffset > 600;
      if (shouldShow !== visible) {
        visible = shouldShow;
        btn.classList.toggle('btt-btn--visible', visible);
      }
    }, { passive: true });

    btn.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }

  /* =========================================================
   * 9. LOW STOCK SCARCITY INDICATOR (product pages)
   * ========================================================= */

  function initStockScarcity() {
    if (!window.location.pathname.match(/\/products\//)) return;
    if (document.querySelector('.stock-scarcity')) return;

    /* Read inventory from Liquid-injected JSON (theme.liquid) */
    var dataEl = document.getElementById('skymedic-product-inventory');
    if (!dataEl) return;

    var inventoryData;
    try { inventoryData = JSON.parse(dataEl.textContent); } catch (e) { return; }
    if (!inventoryData || !inventoryData.variants) return;

    /* Find selected variant or first available */
    var variant = null;
    var urlParams = new URLSearchParams(window.location.search);
    var variantId = urlParams.get('variant');

    if (variantId) {
      variant = inventoryData.variants.find(function (v) { return v.id === parseInt(variantId, 10); });
    }
    if (!variant) {
      variant = inventoryData.variants.find(function (v) { return v.available; });
    }
    if (!variant || !variant.available) return;

    /* Only show for tracked inventory with low stock */
    if (!variant.inventory_management) return;
    var qty = variant.inventory_quantity;
    if (typeof qty !== 'number' || qty <= 0 || qty > 10) return;

    /* Find insertion point */
    var mainSection = document.querySelector('[id*="__main"]');
    if (!mainSection) return;
    var deliveryEl = mainSection.querySelector('.delivery-countdown');
    var trustEl = mainSection.querySelector('.product-trust');
    var target = deliveryEl || trustEl || mainSection.querySelector('.product-payment-icons') || mainSection.querySelector('span.buy-buttons-block');
    if (!target) return;

    var el = document.createElement('div');
    el.className = 'stock-scarcity';
    el.innerHTML =
      '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/><line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/></svg>' +
      '<span>Only <strong>' + qty + ' left</strong> in stock — order soon</span>';

    target.parentNode.insertBefore(el, target.nextSibling);

    if (!document.getElementById('ss-styles')) {
      var s = document.createElement('style');
      s.id = 'ss-styles';
      s.textContent =
        '.stock-scarcity{display:flex;align-items:center;gap:8px;padding:10px 14px;margin-top:12px;background:#FFF8F0;border:1px solid #F0D8B8;border-radius:6px;font-family:"DM Sans",sans-serif;font-size:13px;color:#1A1A1A;line-height:1.4}' +
        '.stock-scarcity svg{flex-shrink:0;color:#C9A96E}' +
        '.stock-scarcity strong{color:#B8540B;font-weight:600}';
      document.head.appendChild(s);
    }
  }

  /* =========================================================
   * 10. SOCIAL PROOF: "X professionals trust this brand"
   * ========================================================= */

  function initSocialProof() {
    if (!window.location.pathname.match(/\/products\//)) return;
    if (document.querySelector('.social-proof-strip')) return;

    var mainSection = document.querySelector('[id*="__main"]');
    if (!mainSection) return;

    /* Insert above the main product title */
    var titleEl = mainSection.querySelector('h1');
    if (!titleEl) return;

    var lang = (document.documentElement.lang || 'en').toLowerCase();
    var trustedHTML;
    if (lang.indexOf('pt') === 0) {
      trustedHTML = '<span>Aprovado por <strong>mais de 2.000 profissionais</strong> em todo o Brasil</span>';
    } else if (lang.indexOf('fr') === 0) {
      trustedHTML = '<span>Approuvé par <strong>2 000+ professionnels</strong> au Maroc</span>';
    } else {
      trustedHTML = '<span>Trusted by <strong>2,000+ professionals</strong> across the UK</span>';
    }

    var el = document.createElement('div');
    el.className = 'social-proof-strip';
    el.innerHTML =
      '<svg width="14" height="14" viewBox="0 0 24 24" fill="#C9A96E" stroke="none"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>' +
      trustedHTML;

    titleEl.parentNode.insertBefore(el, titleEl);

    if (!document.getElementById('sp-styles')) {
      var s = document.createElement('style');
      s.id = 'sp-styles';
      s.textContent =
        '.social-proof-strip{display:flex !important;align-items:center;gap:6px;margin-bottom:8px;font-family:"DM Sans",sans-serif !important;font-size:12px !important;font-weight:400 !important;color:#6B6B6B !important;line-height:1.3 !important;letter-spacing:normal !important;text-transform:none !important}' +
        '.social-proof-strip strong{color:#1A1A1A !important;font-weight:600 !important;font-size:12px !important}' +
        '.social-proof-strip svg{flex-shrink:0;width:14px;height:14px}';
      document.head.appendChild(s);
    }
  }

  /* =========================================================
   * 11. SOLD TODAY COUNTER (product pages - urgency)
   * ========================================================= */

  function initSoldToday() {
    if (!window.location.pathname.match(/\/products\//)) return;
    if (document.querySelector('.sold-today')) return;

    var mainSection = document.querySelector('[id*="__main"]');
    if (!mainSection) return;

    /* Generate a believable number based on product hash */
    var productHandle = window.location.pathname.split('/products/')[1] || '';
    var hash = 0;
    for (var i = 0; i < productHandle.length; i++) {
      hash = ((hash << 5) - hash) + productHandle.charCodeAt(i);
      hash = hash & hash;
    }
    var soldCount = Math.abs(hash % 20) + 3; /* 3-22 */

    /* Find insertion point after trust indicators */
    var trustEl = mainSection.querySelector('.product-trust');
    var paymentEl = mainSection.querySelector('.product-payment-icons');
    var target = trustEl || paymentEl;
    if (!target) return;

    var lang2 = (document.documentElement.lang || 'en').toLowerCase();
    var soldHTML;
    if (lang2.indexOf('pt') === 0) {
      soldHTML = '<span><strong>' + soldCount + ' pessoas</strong> compraram hoje</span>';
    } else if (lang2.indexOf('fr') === 0) {
      soldHTML = '<span><strong>' + soldCount + ' personnes</strong> ont acheté aujourd\'hui</span>';
    } else {
      soldHTML = '<span><strong>' + soldCount + ' people</strong> bought this today</span>';
    }

    var el = document.createElement('div');
    el.className = 'sold-today';
    el.innerHTML =
      '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#C9A96E" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z"/></svg>' +
      soldHTML;

    target.parentNode.insertBefore(el, target.nextSibling);

    if (!document.getElementById('st-styles')) {
      var s = document.createElement('style');
      s.id = 'st-styles';
      s.textContent =
        '.sold-today{display:flex;align-items:center;gap:8px;padding:10px 14px;margin-top:12px;background:#FFF8F0;border:1px solid #F0D8B8;border-radius:6px;font-family:"DM Sans",sans-serif;font-size:13px;color:#1A1A1A;line-height:1.4}' +
        '.sold-today svg{flex-shrink:0}' +
        '.sold-today strong{color:#1A1A1A;font-weight:600}';
      document.head.appendChild(s);
    }
  }

  /* =========================================================
   * 12. VIEWING NOW COUNTER (product pages - social proof)
   * ========================================================= */

  function initViewingNow() {
    if (!window.location.pathname.match(/\/products\//)) return;
    if (document.querySelector('.viewing-now')) return;

    var mainSection = document.querySelector('[id*="__main"]');
    if (!mainSection) return;

    /* Random but consistent number */
    var productHandle = window.location.pathname.split('/products/')[1] || '';
    var hash = 0;
    for (var i = 0; i < productHandle.length; i++) {
      hash = ((hash << 5) - hash) + productHandle.charCodeAt(i);
      hash = hash & hash;
    }
    var viewCount = Math.abs(hash % 30) + 8; /* 8-37 */

    /* Find insertion point */
    var soldEl = mainSection.querySelector('.sold-today');
    var trustEl = mainSection.querySelector('.product-trust');
    var target = soldEl || trustEl;
    if (!target) return;

    var el = document.createElement('div');
    el.className = 'viewing-now';
    el.innerHTML =
      '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#1B4D6E" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg>' +
      '<span><strong>' + viewCount + ' people</strong> are viewing this right now</span>';

    target.parentNode.insertBefore(el, target.nextSibling);

    if (!document.getElementById('vn-styles')) {
      var s = document.createElement('style');
      s.id = 'vn-styles';
      s.textContent =
        '.viewing-now{display:flex;align-items:center;gap:8px;padding:10px 14px;margin-top:8px;background:#F0F4F8;border:1px solid #D4E0EC;border-radius:6px;font-family:"DM Sans",sans-serif;font-size:13px;color:#1A1A1A;line-height:1.4}' +
        '.viewing-now svg{flex-shrink:0}' +
        '.viewing-now strong{color:#1B4D6E;font-weight:600}';
      document.head.appendChild(s);
    }

    /* Fluctuate the number every 30s for realism */
    setInterval(function() {
      var delta = Math.floor(Math.random() * 3) - 1; /* -1, 0, or 1 */
      viewCount = Math.max(5, viewCount + delta);
      var strongEl = el.querySelector('strong');
      if (strongEl) strongEl.textContent = viewCount + ' people';
    }, 30000);
  }

  /* =========================================================
   * GLOBAL FETCH INTERCEPTOR (single override for all widgets)
   * ========================================================= */

  function initFetchInterceptor() {
    var origFetch = window.fetch;
    window.fetch = function () {
      var args = arguments;
      var url = typeof args[0] === 'string' ? args[0] : (args[0] && args[0].url ? args[0].url : '');
      var result = origFetch.apply(this, args);

      if (url.indexOf('/cart/add') !== -1) {
        result.then(function (response) {
          /* Notify shipping bar */
          document.dispatchEvent(new CustomEvent('skymedic:cart:fetch'));
          /* Clone response to read item data for toast */
          var cloned = response.clone();
          cloned.json().then(function (data) {
            var item = data;
            if (data.items && data.items.length > 0) item = data.items[0];
            if (item && (item.product_title || item.title)) {
              document.dispatchEvent(new CustomEvent('skymedic:cart:item-added', { detail: item }));
            }
          }).catch(function () {});
          return response;
        });
      } else if (url.indexOf('/cart/change') !== -1 || url.indexOf('/cart/update') !== -1) {
        result.then(function (response) {
          document.dispatchEvent(new CustomEvent('skymedic:cart:fetch'));
          return response;
        });
      }

      return result;
    };
  }

  /* =========================================================
   * INIT ALL
   * ========================================================= */

  function init() {
    initProductCardTitleCase();
    initPaymentIcons();
    initProductTrustIndicators();
    initStickyAddToCart();
    initAnnouncementBar();
    initExitIntent();
    initRecentlyViewed();
    initFetchInterceptor();
    initFreeShippingBar();
    initInlineFreeShippingMeter();
    initCartToast();
    initDeliveryCountdown();
    initStockScarcity();
    initSocialProof();
    /* Fabricated urgency removed 2026-06-08 (UK CMA compliance + trust): initSoldToday()
       and initViewingNow() generated fake "X bought today" / "X viewing now" numbers.
       Replace with REAL social proof (e.g. Judge.me review counts) when available. */
    initBackToTop();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

